const SHOP_URL = "https://shop.parfimerija-duro.me";

// The shop route uses the country code, independently of the website language.
export const getShopProductUrl = (handle) =>
  `${SHOP_URL}/me/products/${handle}`;
